import { Injectable } from "@angular/core";
import { gql, Apollo, Query } from "apollo-angular";
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };

export type ChallengeType = 'standard' | 'personalized' | 'noChallenge';

export type GetChallengesQuery = { getChallenges: { id: string, name: string, language: string, type: ChallengeType}[] };

export const GetChallengesDocument = gql`
query getChallenges {
  getChallenges {
    id
    name
  }
}`;


@Injectable({
  providedIn: 'root'
})
export class GetChallengesGQL extends Query<GetChallengesQuery> {
  document = GetChallengesDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}